<script>
import storageService from "@/services/storage.service";
import { revokeSession } from "@/services/api";

import router from "../../index";
import { resetApplicationProgress } from "@/services/applicantProgress";
export default {
  async created() {
    const userType = storageService.getItem("userType");
    await revokeSession();
    storageService.removeItem("accessToken");
    storageService.removeItem("refreshToken");
    storageService.removeItem("userEmail");
    storageService.removeItem("userType");
    resetApplicationProgress();
    if (userType === "applicant") {
      router.push("/login");
    } else {
      router.push("/staff_login?logout");
    }
  },
};
</script>